<template>
	<div id="loading-animation">
		<svg width="320" height="320" viewBox="0 0 324 324" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle id="circle" cx="162" cy="162" r="160" stroke="#FD7B7B" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="8 16 24 32"/>
			<g id="leg">
				<path id="calf" d="M166 38.9486C166 38.9486 135.931 13.8912 125.882 6.36102C112.899 -3.45419 103.499 9.19134 95.372 18.5911C88.465 26.5627 80.805 34.1708 74.5991 42.7137C66.3678 53.6714 54.657 63.8501 41.4143 67.1219C28.1716 70.3936 21.4982 82.7016 6.90526 82.5458C-2.31273 82.5458 5.24342 91.8157 10.2809 92.9322C14.0257 93.4259 17.8341 93.0254 21.3944 91.7637C26.1462 90.3616 31.0278 89.5307 35.7277 87.9727C40.9209 86.2589 46.27 89.8942 51.3074 89.6345C59.7724 89.2191 56.5006 81.8447 61.0447 76.9371C63.1844 74.8396 65.6372 73.0876 68.3152 71.7438C83.8949 62.6816 117.963 59.5657 115.833 32.7946" stroke="#FD7B7B" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
				<path id="thigh" d="M2.36768 2.15552C7.89438 4.46677 12.4721 8.58674 15.3508 13.8403C22.4136 25.9405 25.7372 36.0154 43.9135 48.9985" stroke="#FD7B7B" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
			</g>
		</svg>
		<h2>{{ loadScreenText }}</h2>
	</div>
</svg>

</template>

<script>
export default {
	props: ['loadScreenText']
}
</script>